'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getClientConfig = require('./getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _configConstants = require('../../../config/configConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debugLevel = (0, _getClientConfig2.default)().debugLevel || 0;
var consoleLog = function consoleLog(logLevel, logMethod) {
    return function () {
        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
            values[_key] = arguments[_key];
        }

        if (debugLevel < logLevel) return;
        logMethod.apply(console, values);
    };
};

exports.default = {
    log: consoleLog(_configConstants.DEBUG_LEVEL.FINE, console.log), // eslint-disable-line no-console
    info: consoleLog(_configConstants.DEBUG_LEVEL.INFO, console.info), // eslint-disable-line no-console
    table: consoleLog(_configConstants.DEBUG_LEVEL.INFO, console.table), // eslint-disable-line no-console
    error: consoleLog(_configConstants.DEBUG_LEVEL.ERROR, console.error), // eslint-disable-line no-console
    warn: consoleLog(_configConstants.DEBUG_LEVEL.WARN, console.warn) };


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/logger.js
// module id = 128
// module chunks = 0